"use strict";
/*
 * Created on 12 08 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");

var PriceWithVat_1 = require("./PriceWithVat");
/**
 * Entity that holds calculated (better, aggregated) regular purchase prices for products. The price may be null (currently),
 * typically for products that are made in stores. The prices are calculated every day, the state flags can be used to detect
 * whether price has been changed (it should be up to consumer to remove the flag).
 *
 * @author JMe
 * @author Radek Beran
 * @author Jan Prokop
 */


var ProductPurchasePrice =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(ProductPurchasePrice, _StateDomainObject_1$);

  /**
   * @param id the internal id, this entity is persisted
   * @param productId the id of internal product
   * @param categoryIds list of product category ids to which product belong (for query optimization)
   * @param stateFlags the entity state flags
   * @param avgPrice 30days average cost price from the regular transactions. When there is no price found, apply the fallback.
   * @param priceListPrice open cost price
   */
  function ProductPurchasePrice(id, productId, categoryIds, stateFlags) {
    var _this;

    var avgPrice = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var priceListPrice = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    _classCallCheck(this, ProductPurchasePrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductPurchasePrice).call(this, stateFlags));
    _this.id = id;
    _this.productId = productId;
    _this.categoryIds = categoryIds;
    _this.stateFlags = stateFlags;
    _this.avgPrice = avgPrice;
    _this.priceListPrice = priceListPrice;
    return _this;
  } // extends ProductPrice, that would extend StateDomainObject?

  /**
   * Converter from data-dictionary representation to purchase price.
   */


  _createClass(ProductPurchasePrice, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ProductPurchasePrice(mat.id, mat.productId, mat.categoryIds, mat.stateFlags, mat.avgPrice, mat.priceListPrice);
    }
  }]);

  return ProductPurchasePrice;
}(StateDomainObject_1.StateDomainObject);

exports.ProductPurchasePrice = ProductPurchasePrice; // tslint:disable-next-line:member-ordering

ProductPurchasePrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductPurchasePrice.name);
  return {
    id: builder.id('id'),
    productId: builder.id('productId'),
    categoryIds: builder.listOf(builder.id('categoryIds')),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    avgPrice: builder.opt(builder.obj('avgPrice', PriceWithVat_1.PriceWithVat.schema, PriceWithVat_1.PriceWithVat.fromDataDict)),
    priceListPrice: builder.opt(builder.obj('priceListPrice', PriceWithVat_1.PriceWithVat.schema, PriceWithVat_1.PriceWithVat.fromDataDict))
  };
}();